import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'

const ParagraphContainer = styled.div`
  text-align: center;
`

const Text = styled.div`
  font-size: initial;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: center;
  color: #3c4252;
  margin: 0px;
  ${media.md`  
      font-size: 1.2;
  `};

  & p {
    margin-top: 0;
  }
`

const Paragraph = props => {
  const { paragraph } = props
  return (
    <ParagraphContainer {...props}>
      <Text dangerouslySetInnerHTML={{ __html: paragraph }} />
    </ParagraphContainer>
  )
}

export default Paragraph



// WEBPACK FOOTER //
// ./src/components/section/paragraph/paragraph.js